import { render, staticRenderFns } from "./betParlayStatus.vue?vue&type=template&id=65a1823d&lang=pug&"
import script from "./betParlayStatus.vue?vue&type=script&lang=js&"
export * from "./betParlayStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports